import { render, staticRenderFns } from "./robbery-pno-exit.vue?vue&type=template&id=6c39fc38&scoped=true"
import script from "./robbery-pno-exit.vue?vue&type=script&lang=ts"
export * from "./robbery-pno-exit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c39fc38",
  null
  
)

export default component.exports